const methods = [
  {
    name: 'Input',
    result: 'source.png',
  },
  {
    name: 'Zero-DCE',
    api: '1/zero_dce',
    result: 'zero_dce.jpg',
    ref: 'C. Guo, C. Li, J. Guo, C. C. Loy, J. Hou, S. Kwong, and R. Cong, “Zeroreference deep curve estimation for low-light image enhancement,” in CVPR, 2020, pp. 1780–1789.',
  },
  {
    name: 'Zero-DCE++',
    api: '1/zero_dce_pp',
    result: 'zero_dce_pp.jpg',
    ref: 'C. Li, C. Guo, and C. C. Loy, “Learning to enhance low-light image via zero-reference deep curve estimation,” IEEE Transactions on Pattern Analysis and Machine Intelligence, 2021.',
  },
  // {
  //   name: 'RUAS',
  //   api: '2/ruas',
  //   result: 'ruas.jpg',
  //   ref: 'R. Liu, L. Ma, J. Zhang, X. Fan and Z. Luo, "Retinex-inspired Unrolling with Cooperative Prior Architecture Search for Low-light Image Enhancement," in CVPR, 2021, pp. 10556-10565.',
  // },
  // {
  //   name: 'SCI',
  //   api: '2/sci',
  //   result: 'sci.jpg',
  //   ref: 'L. Ma, T. Ma, R. Liu, X. Fan and Z. Luo, "Toward Fast, Flexible, and Robust Low-Light Image Enhancement," in CVPR, 2022, pp. 5627-5636.',
  // },
  // {
  //   name: 'LightenNet',
  //   api: '2/lighten_net',
  //   result: 'lighten_net.jpg',
  //   ref: 'C. Li, J. Guo, F. Porikli, and Y. Pang, “Lightennet: A convolutional neural network for weakly illuminated image enhancement,” Pattern Recognition Letters, vol. 104, pp. 15–22, 2018.',
  // },
  // {
  //   name: 'EnlightenGAN',
  //   api: '1/enlighten_gan',
  //   result: 'enlighten_gan.jpg',
  //   ref: 'Y. Jiang, X. Gong, D. Liu, Y. Cheng, C. Fang, X. Shen, J. Yang, P. Zhou, and Z. Wang, “Enlightengan: Deep light enhancement without paired supervision,” arXiv preprint arXiv:1906.06972, 2019.',
  // },
  // {
  //   name: 'MBLLEN',
  //   api: '2/mbllen',
  //   result: 'mbllen.jpg',
  //   ref: 'F. Lv, F. Lu, J. Wu, and C. Lim, “Mbllen: Low-light image/video enhancement using cnns,” in BMVC, 2018.',
  // },
  // {
  //   name: 'KinD',
  //   api: '2/kind',
  //   result: 'kind.jpg',
  //   ref: 'Y. Zhang, J. Zhang, and X. Guo, “Kindling the darkness: A practical low-light image enhancer,” in ACMMM, 2019, pp. 1632–1640.',
  // },
  // {
  //   name: 'DRBN',
  //   api: '2/drbn',
  //   result: 'drbn.jpg',
  //   ref: 'W. Yang, S. Wang, Y. Fang, Y. Wang, and J. Liu, “From ﬁdelity to perceptual quality: A semi-supervised approach for low-light image enhancement,” in CVPR, 2020, pp. 3063–3072.',
  // },
  // {
  //   name: 'Retinex-Net',
  //   api: '2/retinex_net',
  //   result: 'retinex_net.jpg',
  //   ref: 'C. Wei, W. Wang, W. Yang, and J. Liu, “Deep retinex decomposition for low-light enhancement,” in BMVC, 2018.',
  // },
  // {
  //   name: 'RRDNet',
  //   api: '1/rrd_net',
  //   result: 'rrd_net.jpg',
  //   ref: 'A. Zhu, L. Zhang, Y. Shen, Y. Ma, S. Zhao, and Y. Zhou, “Zero-shot restoration of underexposed images via robust retinex decomposition,” in ICME, 2020, pp. 1–6.',
  // },
  // {
  //   name: 'TBEFN',
  //   api: '2/tbefn',
  //   result: 'tbefn.jpg',
  //   ref: 'K. Lu and L. Zhang, “Tbefn: A two-branch exposure-fusion network for low-light image enhancement,” IEEE Transactions on Multimedia, 2020.',
  // },
  // // {
  // //   name: 'LLNet',
  // //   api: '2/ll_net',
  // //   result: 'll_net.jpg',
  // //   ref: 'K. G. Lore, A. Akintayo, and S. Sarkar, “Llnet: A deep autoencoder approach to natural low-light image enhancement,” Pattern Recognition, vol. 61, pp. 650–662, 2017.',
  // // },
  // {
  //   name: 'ExCNet',
  //   api: '2/exc_net',
  //   result: 'exc_net.jpg',
  //   ref: 'L. Zhang, L. Zhang, X. Liu, Y. Shen, S. Zhang, and S. Zhao, “Zero-shot restoration of back-lit images using deep internal learning,” in ACMMM, 2019, pp. 1623–1631.',
  // },
  // {
  //   name: 'DSLR',
  //   api: '1/dslr',
  //   result: 'dslr.jpg',
  //   ref: 'S. Lim and W. Kim, “Dslr: Deep stacked laplacian restorer for low-light image enhancement,” IEEE Transactions on Multimedia, 2020.',
  // },
  // {
  //   name: 'KinD++',
  //   api: '2/kind_pp',
  //   result: 'kind_pp.jpg',
  //   ref: 'Y. Zhang, X. Guo, J. Ma, W. Liu, and J. Zhang, “Beyond Brightening Low-light Images,” International Journal of Computer Vision, 2021.',
  // },
];

export default methods;
